<template>
  <div id="cwxx">
    <div v-for="item in list">
      <p><b>{{item.ND}}年度</b></p>
      <p>净资本：{{item.JZB}}</p>
      <p>净资产：{{item.JZC}}</p>
      <p>权益总额：{{item.QYZE}}</p>
      <p>手续费收入：{{item.SXFSR}}</p>
      <p>净利润：{{item.JLR}}</p>
      <p>主审会计事务所：{{item.SWS}}</p>
      <p>审计意见类型：{{item.SJYJ}}</p>
      <div v-if="list.length > 1" class="line"></div>
      <div class="margin-b"></div>
    </div>
  </div>
</template>

<script>
  import ajax from '@/common/ajax/ajax'
  export default {
    name: 'cwxx',
    data () {
      return {
        list: [{nd: '数据读取中'}]
      }
    },
    created: function () {
      ajax.getCwxx().then(
        data => {
          this.list = data
        }
      )
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// cwxx.vue?364b02e8